export const useInputValidator = {
  methods: {
    isNumber(event) {
      const keysAllowed = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "Enter",
      ];
      const keyPressed = event.key;
      if (!keysAllowed.includes(keyPressed)) {
        event.preventDefault();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/useInputValidator.js